import React from "react";
import { getRelationshipLabel, getGenderLabel } from "./rveoHelpers";
import { FamilyGroup } from "../../../../interfaces/rveoSimulations";

interface RVEOBeneficiaryProps {
  beneficiary: FamilyGroup;
  isLast?: boolean;
}

const RVEOBeneficiary: React.FC<RVEOBeneficiaryProps> = ({
  beneficiary,
  isLast = false,
}) => {
  return (
    <div
      className="card-verify"
      style={{
        border: "3px solid #d7dbf5",
        marginTop: "0px",
        padding: "24px 32px 40px",
        marginBottom: isLast ? "0px" : "16px",
      }}
    >
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">
            {getRelationshipLabel(beneficiary.parentesco)}
          </div>
          <div className="card-verify__data">
            {getGenderLabel(beneficiary.genero)}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Fecha de Nacimiento</div>
          <div className="card-verify__data">
            {beneficiary.fechaNacimiento || "-"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Estado de Salud</div>
          <div className="card-verify__data">
            {beneficiary.sano === "S" ? "Sano" : "No Sano"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RVEOBeneficiary;
